import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    brand: "Audio-technica",
    title: "Audio-technica - ath - m50x",
    description: "Closed-Back Studio Headphone",
    price: 11999,
    prevPrice: 13999,
    rating: 4.5,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/audio_technica/AudioTechnica00.png?updatedAt=1682678158403",
    categoryName: "headphone",
    _isBestSeller: true,
    _isNewLaunch: true,
  },
  {
    _id: uuid(),
    brand: "Audio-technica",
    title: "Audio-technica - ath - m20x",
    description: "Closed-Back Studio Headphone",
    price: 4499,
    prevPrice: 5280,
    rating: 4.3,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/audio_technica/AudioTechnica02.png?updatedAt=1682678157364",
    categoryName: "headphone",
    _isBestSeller: false,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "Audeze",
    title: "audeze - lcd2 classic",
    description: "Planar Magnetic Open Backs",
    price: 69999,
    prevPrice: 71999,
    rating: 4.2,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/audeze/Audeze00.png?updatedAt=1682678146433",
    categoryName: "headphone",
    _isBestSeller: true,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "Audeze",
    title: "audeze - lcd2 closed-back",
    description: "Planar Magnetic Closed Backs",
    price: 79999,
    prevPrice: 81000,
    rating: 4.4,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/audeze/Audeze01.png?updatedAt=1682678146690",
    categoryName: "headphone",
    _isBestSeller: true,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "Beyerdynamics ",
    title: "beyerdynamics - dt 770 pro",
    description: "Closed-Back Studio Headphone",
    price: 11990,
    prevPrice: 13000,
    rating: 4.4,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/beyerdynamics/Beyerdynamics00.png?updatedAt=1682678156491",
    categoryName: "headphone",
    _isBestSeller: true,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "Beyerdynamics ",
    title: "beyerdynamics - dt 990 pro",
    description: "Open-Back Studio Headphone",
    price: 11990,
    prevPrice: 13000,
    rating: 4.4,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/beyerdynamics/Beyerdynamics01.png?updatedAt=1682678155858",
    categoryName: "headphone",
    _isBestSeller: true,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "Beyerdynamics ",
    title: "beyerdynamics - dt 700 pro x",
    description: "Closed-Back Studio Headphone",
    price: 19990,
    prevPrice: 22900,
    rating: 4.6,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/beyerdynamics/Beyerdynamics02.png?updatedAt=1682678155472",
    categoryName: "headphone",
    _isBestSeller: true,
    _isNewLaunch: true,
  },
  {
    _id: uuid(),
    brand: "Campfire Audio ",
    title: "campfire audio - cascade",
    description: "Closed-Back Headphones",
    price: 49999,
    prevPrice: 52899,
    rating: 4.1,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/campfire_audio/CampfireAudio00.png?updatedAt=1682678145404",
    categoryName: "headphone",
    _isBestSeller: true,
    _isNewLaunch: true,
  },
  {
    _id: uuid(),
    brand: "Epos",
    title: "epos - pc 8 usb",
    description: "Wired Headset With Microphone",
    price: 2749,
    prevPrice: 3199,
    rating: 3.4,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/epos/EPOS00.png?updatedAt=1682678139821",
    categoryName: "headphone",
    _isBestSeller: false,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "Epos",
    title: "epos - pc 5 chat",
    description: "Wired Headphones for Calls",
    price: 1490,
    prevPrice: 1899,
    rating: 3,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/epos/EPOS01.png?updatedAt=1682678140064",
    categoryName: "headphone",
    _isBestSeller: false,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "Shure",
    title: "shure - aonic 50",
    description: "Noise Cancelling Wireless Headphone",
    price: 24499,
    prevPrice: 26999,
    rating: 4.6,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/shure/Shure01.png?updatedAt=1682678152090",
    categoryName: "headphone",
    _isBestSeller: true,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "Shure",
    title: "shure - aonic 40",
    description: "Noise Cancelling Wireless Headphone",
    price: 19990,
    prevPrice: 21999,
    rating: 4.7,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/shure/Shure02.png?updatedAt=1682678152593",
    categoryName: "headphone",
    _isBestSeller: true,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "Sony",
    title: "sony - mdr-7506",
    description: "Closed-Back Studio Heaphone",
    price: 6999,
    prevPrice: 8599,
    rating: 4.5,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/sony/Sony06.png?updatedAt=1682678133874",
    categoryName: "headphone",
    _isBestSeller: true,
    _isNewLaunch: false,
  },

  {
    _id: uuid(),
    brand: "Blon",
    title: "blon - bl -03",
    description: "In-Ears with 1 Dynamic Driver",
    price: 1990,
    prevPrice: 2299,
    rating: 4.5,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/bcon/Bcon00.png?updatedAt=1682678140617",
    categoryName: "in-ears",
    _isBestSeller: true,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "CCA",
    title: "cca - cra",
    description: "In-Ears with 1 Dynamic Driver",
    price: 1399,
    prevPrice: 1579,
    rating: 3.7,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/cca/CCA02.png?updatedAt=1682678138063",
    categoryName: "in-ears",
    _isBestSeller: false,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "CCA",
    title: "cca - fla",
    description: "In-Ears with 1 Dynamic Driver",
    price: 1090,
    prevPrice: 1299,
    rating: 3.9,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/cca/CCA03.png?updatedAt=1682678137858",
    categoryName: "in-ears",
    _isBestSeller: false,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "fiio",
    title: "fiio - fh3",
    description: "In-Ears With 1 DD + 2 BA Drivers",
    price: 11999,
    prevPrice: 12999,
    rating: 4.1,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/fiio/Fiio00.png?updatedAt=1682678153751",
    categoryName: "in-ears",
    _isBestSeller: true,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "fiio",
    title: "fiio - fd1",
    description: "In-Ears With 1 Dynamic Driver",
    price: 4999,
    prevPrice: 5299,
    rating: 4.3,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/fiio/Fiio05.png?updatedAt=1682678154775",
    categoryName: "in-ears",
    _isBestSeller: true,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "fiio",
    title: "fiio - fh1s",
    description: "In-Ears With 1 DD + 1 BA Drivers",
    price: 5499,
    prevPrice: 6299,
    rating: 4.5,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/fiio/Fiio06.png?updatedAt=1682678155165",
    categoryName: "in-ears",
    _isBestSeller: true,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "IKKO",
    title: "iiko - oh2",
    description: "In-Ears with 1 Dynamic Driver",
    price: 5999,
    prevPrice: 6699,
    rating: 5,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/ikko/IKKO00.png?updatedAt=1682678152560",
    categoryName: "in-ears",
    _isBestSeller: false,
    _isNewLaunch: true,
  },
  {
    _id: uuid(),
    brand: "IKKO",
    title: "iiko - oh1s gems",
    description: " In-Ears With 1 DD + 1 BA Drivers",
    price: 10999,
    prevPrice: 16699,
    rating: 5,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/ikko/IKKO01.png?updatedAt=1682678152753",
    categoryName: "in-ears",
    _isBestSeller: false,
    _isNewLaunch: true,
  },
  {
    _id: uuid(),
    brand: "Kz Acoustics",
    title: "kz - zst x",
    description: " In-Ears With 1 DD + 1 BA Drivers",
    price: 1590,
    prevPrice: 1669,
    rating: 4.4,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/kz_acoustics/KZAcoustics00.png?updatedAt=1682678142700",
    categoryName: "in-ears",
    _isBestSeller: false,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "Kz Acoustics",
    title: "kz - zas",
    description: " In-Ears With 1 DD + 7 BA Drivers",
    price: 6999,
    prevPrice: 7890,
    rating: 4.6,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/kz_acoustics/KZAcoustics07.png?updatedAt=1682678143506",
    categoryName: "in-ears",
    _isBestSeller: false,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "Moondrop",
    title: "moondrop - chu",
    description: " In-Ears With 1 Dynamics Driver",
    price: 1690,
    prevPrice: 2399,
    rating: 4.6,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/moondrop/Moondrop00.png?updatedAt=1682678150190",
    categoryName: "in-ears",
    _isBestSeller: false,
    _isNewLaunch: true,
  },
  {
    _id: uuid(),
    brand: "Sennheiser",
    title: "sennheiser - ie 200",
    description: " In-Ears With 1 Dynamics Driver",
    price: 14990,
    prevPrice: 15299,
    rating: 4.3,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/sennheiser/Sennheiser00.png?updatedAt=1682678162187",
    categoryName: "in-ears",
    _isBestSeller: false,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "Sennheiser",
    title: "Sennheiser - ie 300",
    description: " In-Ears With 1 Dynamics Driver",
    price: 32990,
    prevPrice: 35000,
    rating: 4.1,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/sennheiser/Sennheiser01.png?updatedAt=1682678162197",
    categoryName: "in-ears",
    _isBestSeller: false,
    _isNewLaunch: false,
  },

  {
    _id: uuid(),
    brand: "Marshall",
    title: "Marshall - Major IV",
    description: " Wireless Headphone",
    price: 12990,
    prevPrice: 13899,
    rating: 4.8,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/marshall/Marshall00.png?updatedAt=1682678144147",
    categoryName: "wireless",
    _isBestSeller: true,
    _isNewLaunch: true,
  },
  {
    _id: uuid(),
    brand: "Marshall",
    title: "Marshall - Monitor II A.N.C.",
    description: " Noise Cancelling Wireless Heaphone",
    price: 24990,
    prevPrice: 25000,
    rating: 4.8,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/marshall/Marshall02.png?updatedAt=1682678143979",
    categoryName: "wireless",
    _isBestSeller: true,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "Sennheiser",
    title: "Sennheiser - momentum",
    description: " Noise Cancelling True Wireless Earbuds",
    price: 19890,
    prevPrice: 21899,
    rating: 4.7,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/sennheiser/Sennheiser04.png?updatedAt=1682678162624",
    categoryName: "wireless",
    _isBestSeller: false,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "Sennheiser",
    title: "Sennheiser - cx plus",
    description: " True Wireless Earbuds",
    price: 12890,
    prevPrice: 14999,
    rating: 4.7,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/sennheiser/Sennheiser05.png?updatedAt=1682678162340",
    categoryName: "wireless",
    _isBestSeller: true,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "Shure",
    title: "shure - aonic 215 gen 2",
    description: " True Wireless Earbuds",
    price: 19999,
    prevPrice: 24999,
    rating: 4.5,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/shure/Shure00.png?updatedAt=1682678151782",
    categoryName: "wireless",
    _isBestSeller: true,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "Sony",
    title: "sony - wf-c500",
    description: " True Wireless Earbuds",
    price: 5990,
    prevPrice: 6299,
    rating: 4.2,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/shure/Shure00.png?updatedAt=1682678151782",
    categoryName: "wireless",
    _isBestSeller: false,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "Sony",
    title: "sony - wf-100xm4",
    description: "  Noise Cancelling True Wireless Earbuds",
    price: 16990,
    prevPrice: 19990,
    rating: 4.6,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/sony/Sony02.png?updatedAt=1682678133877",
    categoryName: "wireless",
    _isBestSeller: false,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "Sony",
    title: "sony - wh-1000xm5",
    description: " Flagship Noise Cancelling Headphones",
    price: 29990,
    prevPrice: 31990,
    rating: 4.7,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/sony/Sony04.png?updatedAt=1682678131006",
    categoryName: "wireless",
    _isBestSeller: true,
    _isNewLaunch: true,
  },
  {
    _id: uuid(),
    brand: "Sony",
    title: "sony - wh-xb910n",
    description: " Flagship Noise Cancelling Headphones",
    price: 14990,
    prevPrice: 17899,
    rating: 4.5,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/sony/Sony05.png?updatedAt=1682678131248",
    categoryName: "wireless",
    _isBestSeller: true,
    _isNewLaunch: true,
  },

  {
    _id: uuid(),
    brand: "Audeze",
    title: "audeze - 1/4’’ to 1/8’’ adapter",
    description: "6.35mm to 3.5mm Stereo Adapter",
    price: 1999,
    prevPrice: 2599,
    rating: 4.5,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/audeze/Audeze04.png?updatedAt=1682678147550",
    categoryName: "accessories",
    _isBestSeller: false,
    _isNewLaunch: true,
  },

  {
    _id: uuid(),
    brand: "Blon",
    title: "blon - 4 core plated cable",
    description: "sliver-plated Upgrade Cable",
    price: 849,
    prevPrice: 1599,
    rating: 3.5,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/bcon/Bcon01.png?updatedAt=1682678140699",
    categoryName: "accessories",
    _isBestSeller: false,
    _isNewLaunch: true,
  },

  {
    _id: uuid(),
    brand: "Campfire Audio",
    title: "campfire audio - ear pads",
    description: "soft pad",
    price: 3999,
    prevPrice: 4289,
    rating: 3.9,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/campfire_audio/CampfireAudio02.png?updatedAt=1682678144939",
    categoryName: "accessories",
    _isBestSeller: false,
    _isNewLaunch: true,
  },

  {
    _id: uuid(),
    brand: "Comply",
    title: "comply - smartcore",
    description: "Memory Foam Eartips",
    price: 1599,
    prevPrice: 2000,
    rating: 4,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/comply/Comply00.png?updatedAt=1682678131410",
    categoryName: "accessories",
    _isBestSeller: false,
    _isNewLaunch: false,
  },

  {
    _id: uuid(),
    brand: "Comply",
    title: "comply - p-series",
    description: "Memory Foam Eartips",
    price: 1799,
    prevPrice: 2000,
    rating: 4.2,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/comply/Comply01.png?updatedAt=1682678131322",
    categoryName: "accessories",
    _isBestSeller: false,
    _isNewLaunch: false,
  },

  {
    _id: uuid(),
    brand: "dekoni audio",
    title: "dekoni audio - elite earpads",
    description: "Elite Velour Replacement Ear Pads",
    price: 4499,
    prevPrice: 5600,
    rating: 4.2,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/dekoni_audio/Dekoni00.png?updatedAt=1682678159797",
    categoryName: "accessories",
    _isBestSeller: false,
    _isNewLaunch: true,
  },
  {
    _id: uuid(),
    brand: "dekoni audio",
    title: "dekoni audio - elite earpads",
    description: "Elite Velour Replacement Ear Pads",
    price: 4499,
    prevPrice: 5600,
    rating: 4,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/dekoni_audio/Dekoni05.png?updatedAt=1682678159066",
    categoryName: "accessories",
    _isBestSeller: false,
    _isNewLaunch: true,
  },
  {
    _id: uuid(),
    brand: "effect audio",
    title: " effect audio - vogue series",
    description: "Pure UP-OCC 2-Pin/MMCX Upgrade Cable",
    price: 10999,
    prevPrice: 11999,
    rating: 4,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/effect_audio/EffectAudio00.png?updatedAt=1682678130314",
    categoryName: "accessories",
    _isBestSeller: false,
    _isNewLaunch: true,
  },

  {
    _id: uuid(),
    brand: "Sony",
    title: " sony - srs-xe300",
    description: "Wireless Bluetooth Speaker",
    price: 19990,
    prevPrice: 21999,
    rating: 4.5,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/sony/Sony07.png?updatedAt=1682678133106",
    categoryName: "home-audio",
    _isBestSeller: true,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "Marshall",
    title: " Marshall - Stockwell II",
    description: "Portable Bluetooth Speakers",
    price: 21999,
    prevPrice: 23599,
    rating: 5,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/marshall/Marshall01.png?updatedAt=1682678143853",
    categoryName: "home-audio",
    _isBestSeller: true,
    _isNewLaunch: false,
  },
  {
    _id: uuid(),
    brand: "Marshall",
    title: " Marshall - Stanmore III",
    description: "Wireless Home Speakers",
    price: 41999,
    prevPrice: 43599,
    rating: 4.5,
    image:
      "https://ik.imagekit.io/u6itcrvxy/heaphone_collection/marshall/Marshall03.png?updatedAt=1682678144892",
    categoryName: "home-audio",
    _isBestSeller: true,
    _isNewLaunch: false,
  },
];
